const initState = {
  position: [],
  successFetching: false,
  errorFetching: false,
};

export default initState;
